/** Which referral programme `/refer` is showing. */
export type ReferralProgram = 'standard' | 'ambassador'

/**
 * Read the programme out of a `/refer` query string.
 *
 * Anything unrecognised resolves to `standard`, matching the backend parser:
 * guessing wrong must mean "the referrer earns", never "we silently promise a
 * stranger $200 of hotel credit".
 */
export function referralProgramFromSearch(search: string): ReferralProgram {
  const value = new URLSearchParams(search).get('program')?.trim().toLowerCase()
  return value === 'ambassador' ? 'ambassador' : 'standard'
}

/** OAuth `source` value that returns each referral programme to `/refer`. */
export const REFER_LOGIN_SOURCE: Record<ReferralProgram, string> = {
  standard: 'refer',
  ambassador: 'refer_ambassador',
}

/** Login query that carries the selected referral programme through OAuth. */
export function referralLoginSearchFromSearch(search: string): string {
  const program = referralProgramFromSearch(search)
  return `?source=${REFER_LOGIN_SOURCE[program]}`
}
